import React, { useEffect, useState } from 'react'
import { Controller, useForm } from "react-hook-form";
import Select from 'react-select'
import { loadCSC } from "../../util/country-service";

function CountrySelect({callback,errorsmsg,value}) {
    const EntityForm = useForm({
        defaultValues:{
            city:"",
            state:"",
            country:"",
        }
    })
    const [Countries, setCountries] = useState([]);
    const [Value2, setValue2] = useState([])
    
    useEffect(() => {
        let isMounted = true;
        loadCSC().then((csc) => {
            if (!isMounted) return;
            const array = csc.Country.getAllCountries().filter(
              (x) => csc.State.getStatesOfCountry(x.isoCode).length !== 0
            );
            setValue2(array.filter((r) => r.name === value));
            setCountries(array);
        }).catch(console.error);
        return () => { isMounted = false; };
    }, [value])

    const {setValue, getValues, control} = EntityForm;
  return (
    <>
      <div className={"input_wrapeer m0 wd_30"}>
        <p className={"label_styles"}>
        Country*
        </p>
        <div className={""}>
            <Controller
            name={"country"}
            control={control}
            rules={{ required: "Please select your Country" }}
            defaultValue='India'
            render={({ field, formState: { errors } }) => (
              <>
              <Select
                {...field}
                className={`selectBox_styles ${errors?.country ? "border_red" : ""}`}
                classNamePrefix="select"
                isSearchable={true}
                options={Countries}
                placeholder={getValues("country")}
                getOptionLabel={(options) => options['name']}
                getOptionValue={(options) => options['flag']}
                value={Value2}
                onChange={(e) => {
                    setValue("country", e)
                    callback(e)
                }}
              />
                  <p className="help is-input-danger-message">{errorsmsg ? errorsmsg : <span>&nbsp;</span>}</p> 
              </>
            )}
          />
        </div>
      </div>
    </>
  )
}

function StateSelect({countryValue, callback, value, errorsmsg, disabled, label}) {
    const EntityForm = useForm({
        defaultValues:{
            city:"",
            state: value,
            country:"",
        }
    })
    const { setValue, control } = EntityForm;
    const [States, setStates] = useState([])
    const [Value2, setValue2] = useState([])

    useEffect(() => {
        let isMounted = true;
        loadCSC().then((csc) => {
            if (!isMounted) return;
            const CountryList = csc.Country.getAllCountries().filter(
              (r) => r.name === (countryValue === "Hong Kong" ? "Hong Kong S.A.R." : countryValue)
            );
            const Statess = csc.State.getStatesOfCountry(CountryList[0]?.isoCode);
            setValue2(Statess.filter((r) => r.name === value));
            setStates(Statess);
            setValue("state", value);
        }).catch(console.error);
        return () => { isMounted = false; };
    }, [countryValue, value, setValue]);

  return (
    <div className={label ? "input_wrapeer" : "input_wrapeer m0 wd_30"}>
        {label ? '' : <p className={"label_styles"}>State*</p>}
        <div className={""}>
            <Controller
            name={"state"}
            control={control}
            render={({ field, formState: { errors } }) => (
              <>
              <Select
                {...field}
                className={`selectBox_styles ${errors?.state ? "border_red" : ""}`}
                classNamePrefix="select"
                isSearchable={true}
                options={States}
                getOptionLabel={(options) => options['name']}
                getOptionValue={(options) => options['name']}
                value={Value2}
                isDisabled={disabled}
                onChange={(e) => { 
                    setValue("state", e)
                    setValue2(e)
                    callback(e)
                }}
              />
                 <p className="help is-input-danger-message">{errorsmsg ? errorsmsg : <span>&nbsp;</span>}</p> 
              </>
            )}
          />
        </div>
    </div>
  )
}

function CitySelect({callback, stateValue, value, errorsmsg, disabled, label}) {
  const [CityList, setCityList] = useState([])
  const [Value2, setValue2] = useState([])
  const EntityForm = useForm({
      defaultValues:{
          city:"",
          state: stateValue,
          country:"",
      }
  })

  useEffect(() => {
    let isMounted = true;
    loadCSC().then((csc) => {
      if (!isMounted) return;
      const CurrentState = csc.State.getAllStates().filter(
        (r) => r.name === stateValue
      );
      const cityList = csc.City?.getCitiesOfState(CurrentState[0]?.countryCode, CurrentState[0]?.isoCode) || [];
      setValue2(cityList.filter((r) => r.name === value));
      setCityList(cityList);
    }).catch(console.error);
    return () => { isMounted = false; };
  }, [stateValue, value]);
    
  const { setValue, control } = EntityForm;
  return (
    <>
    <div className={label ? "input_wrapeer" : "input_wrapeer m0 wd_30"}>
        {label ? '' : <p className={"label_styles"}>City*</p>}
        <div className={""}>
            <Controller
            name={"city"}
            control={control}
            render={({ field, formState: { errors } }) => (
              <>
              <Select
                {...field}
                className={`selectBox_styles ${errors?.city ? "border_red" : ""}`}
                classNamePrefix="select"
                isSearchable={true}
                options={CityList}
                isDisabled={disabled}
                getOptionLabel={(options) => options['name']}
                getOptionValue={(options) => options['name']}
                value={Value2}
                onChange={(e) => {
                    setValue("city", e)
                    callback(e)
                }}
              />
            <p className="help is-input-danger-message">{errorsmsg ? errorsmsg : <span>&nbsp;</span>}</p> 
              </>
            )}
          />
        </div>
    </div>
    </>
  )
}

export default CountrySelect;
export { StateSelect, CountrySelect, CitySelect };